import type { TokenPair } from '../types/api';

import { emitTokenUpdated } from './sessionEvents';

const ACCESS_KEY = 'rg_admin_access_token';
const REFRESH_KEY = 'rg_admin_refresh_token';

export function getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_KEY);
}

export function setTokens(tokens: TokenPair): void {
    localStorage.setItem(ACCESS_KEY, tokens.access_token);
    localStorage.setItem(REFRESH_KEY, tokens.refresh_token);
    emitTokenUpdated(tokens.access_token);
}

export function clearTokens(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
}

export function hasTokens(): boolean {
    return Boolean(getAccessToken());
}
